// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckBlock-modulebody__suD3j";
var _2 = "ApplicantCreditCheckBlock-moduledocumentLabel__bKVxW";
var _3 = "ApplicantCreditCheckBlock-moduleline__iu1fZ";
var _4 = "ApplicantCreditCheckBlock-modulelines__q84pP";
var _5 = "ApplicantCreditCheckBlock-modulerows__ENtqC";
export { _1 as "body", _2 as "documentLabel", _3 as "line", _4 as "lines", _5 as "rows" }
